import { Container, Typography, Box, Grid, Link, Divider, IconButton } from '@mui/material';
import { Mail, Phone, MapPin } from 'lucide-react';
import { SlSocialLinkedin, SlSocialFacebook,SlSocialInstagram} from 'react-icons/sl';
import { FaXTwitter} from 'react-icons/fa6';
import { Link as RouterLink } from 'react-router-dom';
import MouseoverPopup from './MouseoverPopup'; // Assuming this is the path to your MouseoverPopup component

const Footer = () => {

  return (
    <Box 
      component="footer" 
      sx={{ 
        backgroundColor: '#1a237e',
        color: 'white',
        pt: 8,
        pb: 4,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              {/* <Brain size={32} className="mr-2" /> */}
              <Box 
            component="img" 
            src="/assets/RIC_NoText.png" 
            alt="RecruitAI Logo" 
            sx={{ 
              width: 32, 
              height: 32, 
              mr: 2,
              display: { xs: 'none', md: 'flex' }
            }} 
          />
              <Typography variant="h6" component="div" sx={{ fontWeight: 700 }}>
                RECRUITMENT INTELLIGENCE<span style={{ fontSize: '1.0em', verticalAlign: 'super' }}>®</span>
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ mb: 3, opacity: 0.8 }}>
              Transforming the recruiting industry with advanced AI technology. We help companies find the perfect candidates faster and more efficiently.
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <IconButton size="small" sx={{ color: 'white', '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' } }}>
                <FaXTwitter size={18} />
              </IconButton>
              <IconButton 
                size="small" 
                onClick={() => window.open('https://www.linkedin.com/company/recruitment-intelligence/?viewAsMember=true', '_blank', 'noopener,noreferrer')}
                sx={{ color: 'white', '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' } }}
                aria-label="LinkedIn"
              >
                <SlSocialLinkedin size={18} />
              </IconButton>              
              <IconButton 
                size="small" 
                onClick={() => window.open('https://www.facebook.com/recruitmentintelligence', '_blank', 'noopener,noreferrer')}
                sx={{ color: 'white', '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' } }}
                aria-label="Facebook"
              >
                <SlSocialFacebook size={18} />
              </IconButton>
              <IconButton size="small" sx={{ color: 'white', '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' } }}>
                <SlSocialInstagram size={18} />
              </IconButton>
            </Box>
          </Grid>
          
          <Grid item xs={4} sm={3} md={2}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
              Company
            </Typography>
            <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
              {[
                { name: 'About Us', path: '/aboutus' },
                // { name: 'Careers', path: '/careers' },
                { name: 'Press', path: '/press' }
              ].map((item) => (
                <Box component="li" key={item.name} sx={{ mb: 1 }}>
                  <Link 
                    component={RouterLink}
                    to={item.path}
                    underline="hover" 
                    sx={{ 
                      color: 'rgba(255,255,255,0.7)',
                      '&:hover': { color: 'white' },
                      transition: 'color 0.2s',
                    }}
                  >
                    {item.name}
                  </Link>
                </Box>
              ))}
            </Box>
          </Grid>

          <Grid item xs={6} sm={3} md={2}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
              Contact
            </Typography>
            <Box sx={{ mb: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Mail size={16} className="mr-2" style={{ marginRight: '8px' }} />
                <Typography variant="body2" sx={{ opacity: 0.8 }}>
                  info@recruitmentintelligence.com
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Phone size={16} className="mr-2" style={{ marginRight: '8px' }} />
                <Typography variant="body2" sx={{ opacity: 0.8 }}>
                  +1 (954) 342-0550
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                <MapPin size={16} className="mr-2" style={{ marginRight: '8px' }} />
                <Typography variant="body2" sx={{ opacity: 0.8}}>
                  2200&nbsp;North&nbsp;Commerce&nbsp;Pkwy<br/>STE 200<br/> Weston, FL 33326
                </Typography>
              </Box>
             </Box>
          </Grid>
        </Grid> 

        <Box sx={{ mt: 4 }}>
          <MouseoverPopup />
        </Box>

        <Divider sx={{ my: 4, borderColor: 'rgba(255,255,255,0.1)' }} />
        
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'center', sm: 'flex-start' } }}>
          <Typography variant="body2" sx={{ opacity: 0.7, mb: { xs: 2, sm: 0 } }}>
            © {new Date().getFullYear()} RecruitmentIntelligence, LLC  All rights reserved.
          </Typography>
          <Box sx={{ display: 'flex', gap: 3 }}>
            <Link href="./RIC-PrivacyPolicy.pdf" underline="hover" sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.875rem' }}>
              Privacy Policy
            </Link>
            <Link href="./RIC-TermsOfService.pdf" underline="hover" sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.875rem' }}>
              Terms of Service
            </Link>
{/*             <Link href="#" underline="hover" sx={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.875rem' }}>
              Cookies
            </Link> */}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;